export const PAGINATION_SIZES = {
    DESKTOP: 9,
    MOBILE: 6,
};

export const IMAGE_URL =
    'https://a.1stdibscdn.com/trade/TRADE_PROJECT/1588883542_g93rq/Bush_OMS_SKJ_03_LO.jpg';

export const DEFAULT_QUESTIONS_PER_PAGE = 20;
export const ANSWERS_URL_LABEL = 'answers';
